import { setApp, getApp } from '../index';

function checkPromo(pCode) {
    var jsonPromo = {
        PromoCode: pCode
    };
    
    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://apps.vantagewest.org/ValidPromo');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('VW_Token', '029a45c9f8ae78719f7cb70dc931d13c:33664d414f60954d15cefdd6c4ceace168d4e9ff7e5fcfa7a6aeb783c0fd7675');
    xhr.onload = function () {
        if (xhr.status === 200) {
            setApp('blockPromo', false);
            setApp('promoCode', pCode);
        }
        else if (xhr.status !== 200) {

            // This would fix the issue of alert dialog got display twice since the render method would be called twice due to react router
            if(getApp('blockPromo') !== true) {
                alert("This promotion is no longer available...");
                setApp('blockPromo', true);
            }
            window.location.href = "/loan-application/not-found";
        }
    }

    xhr.send(JSON.stringify(jsonPromo));
}

export default checkPromo;